// import React, { useEffect, useRef, useState } from 'react'
// import './PopularProducts.css'
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import { Autoplay, Navigation, Pagination } from "swiper/modules";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
// import CommonHeadingAfterLine from '../../Common-Component/CommonHeadingAfterLine/CommonHeadingAfterLine';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
// import { encodeId } from '../../../utils/common';

// const PopularProducts = ({ productdata}) => {

//     const swiperRef = useRef(null);
//     const [swiperInstance, setSwiperInstance] = useState(null);

//     const handleMainSliderClick = (direction) => {

//         if (swiperInstance) {
//             if (direction === "prev") {
//                 swiperInstance.slidePrev();
//             } else if (direction === "next") {
//                 swiperInstance.slideNext();
//             }
//         }
//     };

//     // const data = [
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     //     {
//     //         product_name: "Apparel",
//     //         image: "/assets/Images/Home/Products/img2.png"
//     //     },
//     //     {
//     //         product_name: "Corporate Gifts",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     //     {
//     //         product_name: "Drinkware ",
//     //         image: "/assets/Images/Home/Products/img2.png"
//     //     },
//     //     {
//     //         product_name: "Mailer Boxes",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img2.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img2.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img2.png"
//     //     },

//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img2.png"
//     //     },
//     //     {
//     //         product_name: "Business Cards",
//     //         image: "/assets/Images/Home/Products/img1.png"
//     //     },
//     // ]

//     return (
//         <section className='PopularProducts'>
//             <div className='container'>
//                 <div class="section_heading_div">
//                     <p class="heading_text">
//                         Popular Products
//                     </p>
//                     <p className='sub_text'>
//                         Tried, Trusted, and Loved by You!
//                     </p>
//                 </div>

//                 <div className='product_swiper_div' >
//                     <Swiper
//                         ref={swiperRef}
//                         spaceBetween={30}
//                         pagination={{
//                             dynamicBullets: true,
//                             clickable: true,
//                         }}
//                         autoplay={{
//                             delay: 2000, // 3 seconds delay between slides
//                             disableOnInteraction: false,
//                           }}
//                         modules={[Pagination]}
//                         onSwiper={(swiper) => setSwiperInstance(swiper)}
//                         className="productSwiper"
//                         breakpoints={{
//                             0: {
//                                 slidesPerView: 2,

//                             },
//                             340: {
//                                 slidesPerView: 2.2,

//                             },
//                             420: {
//                                 slidesPerView: 2.5,
//                                 spaceBetween: 20,
//                             },
//                             486: {
//                                 slidesPerView: 3,
//                                 spaceBetween: 20,
//                             },
//                             768: {
//                                 slidesPerView: 3.8,

//                             },
//                             992: {
//                                 slidesPerView: 4.2,

//                             },
//                             1200: {
//                                 slidesPerView: 5,

//                             },
//                             1400: {
//                                 slidesPerView: 6,

//                             },

//                         }}
//                     >

//                         {productdata?.length > 0 && productdata?.map((item) => {
//                             return (
//                                 <SwiperSlide >
//                                       <Link to={`/product-details-page/${encodeId(item?.id)}`}>
//                                     <div className='popular_product_card'>
//                                         <div className='product_img_holder'>
//                                             <img src={process.env.REACT_APP_IMG_URL+ item?.Product_Images[0]?.image} className='product_img' />
//                                         </div>
//                                         <div className='product_name_div'>
//                                             <p className='product_name'>
//                                                 {item?.name}
//                                             </p>
//                                         </div>
//                                     </div></Link>
//                                 </SwiperSlide>
//                             )
//                         })}
//                     </Swiper>

//                     <div className="btn_backgound_holder">
//                         <div className="silder-btn">
//                             <div className="back_btn_holder">
//                                 <div
//                                     className="back-btn"
//                                     onClick={() => handleMainSliderClick("prev")}
//                                 >
//                                     <p> <FontAwesomeIcon icon={faAngleLeft} /></p>
//                                 </div>
//                             </div>
//                             <div className="next_btn_holder">
//                                 <div
//                                     className="next-btn"
//                                     onClick={() => handleMainSliderClick("next")}
//                                 >
//                                     <p> <FontAwesomeIcon icon={faAngleRight} /></p>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>

//                 </div>

//             </div>
//         </section>
//     )
// }

// export default PopularProducts
import React from "react";
import "./PopularProducts.css";
import { encodeId } from '../../../utils/common';
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";
import { Link } from "react-router-dom";

const PopularProducts = ({ productdata }) => {
  const data = [
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img1.png",
    },
    { product_name: "Apparel", image: "/assets/Images/Home/Products/img2.png" },
    {
      product_name: "Corporate Gifts",
      image: "/assets/Images/Home/Products/img1.png",
    },
    {
      product_name: "Drinkware",
      image: "/assets/Images/Home/Products/img2.png",
    },
    {
      product_name: "Mailer Boxes",
      image: "/assets/Images/Home/Products/img1.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img2.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img1.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img2.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img2.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img1.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img1.png",
    },
    {
      product_name: "Business Cards",
      image: "/assets/Images/Home/Products/img2.png",
    },
 
  ];

  return (
    <section className="PopularProducts">
      <div className="custom_container">
        <Homepage_common_heading
          headingText={"Our Most Popular Picks"}
          headingDescText={"Popular products that leave a lasting impression."}
        />

        {/* GRID */}
        <div className="product_grid">
          <div className="row">
            {data.map((item, index) => (
              <div className="col-xxl-2 col-xl-3 col-lg-3  col-md-4 col-sm-4 col-6">
                <div className="popular_product_card" key={index}>
                  <div className="product_img_holder">
                    <img
                      src={item.image}
                      alt={item.product_name}
                      className="product_img"
                    />
                  </div>

                  <div className="product_name_div">
                    <p className="product_name">{item.product_name}</p>
                  </div>
                </div>
              </div>
            ))}

            {/* {productdata?.length > 0 &&
              productdata?.map((item) => {
                return (
                  <Link to={`/product-details-page/${encodeId(item?.id)}`}>
                    <div className="popular_product_card">
                      <div className="product_img_holder">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL +
                            item?.Product_Images[0]?.image
                          }
                          className="product_img"
                        />
                      </div>
                      <div className="product_name_div">
                        <p className="product_name">{item?.name}</p>
                      </div>
                    </div>
                  </Link>
                );
              })} */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularProducts;
